import { Avatar } from "@mui/material";
import React, { forwardRef } from "react";
import "./Message.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/userSlice";

const Message = forwardRef(
  ({ id, content: { date, msg, photo, uid } }, ref) => {
    const user = useSelector(selectUser);

    function formatAMPM(date) {
      date = new Date(date);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    }

    console.log(user.uid, uid);

    return (
      <div
        ref={ref}
        className={`message ${user.uid === uid && "message__sender"}`}
      >
        <Avatar className="message__photo" src={photo} />
        <p>{msg}</p>
        <small>{formatAMPM(new Date(date.toDate()))}</small>
      </div>
    );
  }
);

export default Message;
